
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
})
